import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StartsAtComponent } from './starts-at.component';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';

@NgModule({
  declarations: [StartsAtComponent],
  imports: [
    CommonModule,
    FormsModule, ReactiveFormsModule,
    BsDatepickerModule.forRoot(),    
  ],
  exports:[StartsAtComponent],

})
export class StartsAtModule { }
